export const phoneNumberToLink = (str: string): string =>
    `tel:${str.charAt(0) === '+' ? '+' : ''}${str.replace(/[^\d]/g, '')}`;

export default phoneNumberToLink;
